module.exports = __webpack_public_path__ + "img/VU.bc5ecab2.png";